import './App.css';
import About from './components/About';
import Book from './components/Book';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Home from './components/Home';
import NavBar from './components/NavBar';
// import Payment from './components/Payment';
// import Subscription from './components/Subscription';

function App() {
  return (
    <div className="App">
      <div className="flex justify-center">
  <NavBar />
</div>

      <Home/>
      <Book/>
      {/* <Payment/> */}
      <About/>
      {/* <Subscription/> */}
      {/* <Service/> */}
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
